module.exports = __webpack_public_path__ + "static/WebAR_placeholder-726b364d91cef1223a4274f292402a82.png";